<template>
  <div class="div_footer">
    <div class="div_layout" style="padding-top: 50px">
      <el-divider />
    </div>
    <div class="flexBox div_layout" style="margin-top: -100px">
      <div class="div_h_span">
        <h3>关于我们</h3>
        <div
          v-for="(router, index) in routerList"
          :key="index"
          v-if="index !== 0"
        >
          <el-link
            :underline="false"
            @click="turnTo(router.router)"
            class="el-link_to_span"
            >{{ router.title }}</el-link
          ><br />
        </div>
      </div>
      <div class="div_h_span" style="text-align: center">
        <h3>关注我们</h3>
        <div class="div_code">
          <div
            v-for="(attention, index) in footerObj.attention"
            :key="index"
            class="div_code div_column"
          >
            <el-image :src="attention.picture" class="image_code" />
            <span>{{ attention.title }}</span>
          </div>
        </div>
      </div>
      <div class="div_h_span">
        <h3>联系我们</h3>
        <div v-for="(contact, index) in footerObj.contact" :key="index">
          <span>{{ contact }}</span
          ><br />
        </div>
      </div>
    </div>
    <div class="div_layout div-footer">
      <span class="span_footer">{{ footerObj.copyright }}</span>
      <div
        style="
          margin: 8px 10px;
          height: 24px;
          width: 1px;
          background-color: #4d4d4d;
        "
      ></div>
      <a :href="footerObj.recordUrl" target="_blank" class="span_footer">{{
        footerObj.record
      }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      routerList: global.routerList,
      footerObj: global.footerObj,
      nowUrl: "",
    };
  },
  mounted() {
    this.nowUrl = this.$route.path;
  },
  methods: {
    turnTo(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>

<style scoped>
.div_footer {
  height: 300px;
  /*background-color: rgba(230,230,230,0.7);*/
  background: url("../../assets/img/footer/footerBackground.jpg") no-repeat
    scroll 50% 50%;
  background-size: cover;
  margin-top: 50px;
  width: 100%;
  min-width: 1200px;
  color: #ffffff;
}
.div_layout {
  width: 1100px;
  margin: auto;
}
.div_h_span {
  margin: 20px 50px 0;
  height: 200px;
  text-align: left;
}

.el-link_to_span {
  color: #ffffff !important;
  font-size: 16px;
}
.el-link_to_span:hover {
  color: #ffffff !important;
  font-size: 18px;
  font-weight: bolder;
}

.div_code {
  display: flex;
}
.div_column {
  flex-direction: column;
}
.image_code {
  width: 100px;
  height: 100px;
  margin: 0 10px;
}

.div-footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  line-height: 40px;
  font-size: 12px;
  letter-spacing: 1px;
}
.span_footer {
  color: #4d4d4d;
}
</style>



// WEBPACK FOOTER //
// src/components/footerComponent/footerComponent.vue